import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables'

import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import NotFoundMessage from 'components/NotFoundMessage'
import TableLoadingAnimation from 'components/TableLoadingAnimation'
import { Add } from '@mui/icons-material'
import moment from 'moment'
import { DialogConfirm } from 'components'

import generateOptions from '../generateOptions'
import { columns } from './columns'
import CnaeForm from './CnaeForm'
import { deleteCnae, getAllCnaes } from "../../../services/apiKYP"
import { OPERATION_MESSAGES } from "../../../utils/constants/operations"

function Cnaes() {
  const token = useSelector((state) => state.auth.access_token)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [showEditorDialog, setShowEditorDialog] = useState(false)
  const [showRemoveDialog, setShowRemoveDialog] = useState(false)
  const [selectedCnae, setSelectedCnae] = useState(null)

  const handleAdd = () => {
    setShowEditorDialog(true)
  }

  const handleEdit = (cnae) => {
    setSelectedCnae(cnae)
    setShowEditorDialog(true)
  }

  const handleOpenRemove = (cnae) => {
    setSelectedCnae(cnae)
    setShowRemoveDialog(true)
  }

  const actions = [
    { icon: Add, callback: handleAdd, tooltip_text: 'Adicionar novo CNAE' },
  ]

  const filename = `CNAES_restritivos_${moment().format('DD_MM_YYYY_HH_mm_ss')}`

  const options = generateOptions(filename, actions)

  const initializeDataState = (rawData) => {
    if (rawData?.length > 0) {
      const transformedData = rawData.map((row) => ({
        ...row,
        actions: {
          edit: () => handleEdit(row),
          remove: () => handleOpenRemove(row),
        },
      }))
      setData(transformedData)
    }
  }

  const loadData = () => {
    setLoading(true)

    getAllCnaes(token, {})
      .then((response) => {
        initializeDataState(response.data)
      })
      .catch((error) => {
        console.error(error)
        toast.error(OPERATION_MESSAGES.LOAD_DATA_FAIL)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleClose = () => {
    setShowEditorDialog(false)
    setShowRemoveDialog(false)
    setSelectedCnae(null)
    loadData()
  }

  const handleDelete = async () => {
    deleteCnae(token, selectedCnae.uuid)
      .then((response) => {
        if (response.status === 204) {
          toast.success(OPERATION_MESSAGES.RECORD_REMOVE_SUCCESS)
          handleClose()
        }
      })
      .catch(() => {
        toast.error(OPERATION_MESSAGES.RECORD_REMOVE_FAIL)
      })
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <div>
      {loading ? (
        <TableLoadingAnimation />
      ) : data.length > 0 ? (
        <MUIDataTable data={data} columns={columns} options={options} />
      ) : (
        <NotFoundMessage message='Nenhum resultado encontrado' />
      )}

      <CnaeForm open={showEditorDialog} handleClose={handleClose} cnae={selectedCnae} />

      <DialogConfirm
        open={showRemoveDialog}
        title="Confirmar remoção do CNAE"
        onCancel={handleClose}
        onConfirm={handleDelete}
        contextText={OPERATION_MESSAGES.PERMANENT_ACTION_CONFIRMATION}
      />
    </div>
  )
}

export default Cnaes
